var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStackedLine = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40px",
  height: "30px",
  viewBox: "0 0 40 30",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Report-Editor",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "RptEd5.3-LineChartSingle",
  transform: "translate(-106.000000, -344.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(106.000000, 344.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "background",
  stroke: "#CCCCCC",
  fill: "#FFFFFF",
  x: 0.5,
  y: 0.5,
  width: 39,
  height: 29,
  rx: 2
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-2-Copy-1",
  stroke: "#37809f",
  points: "2 19.7790264 9.59155273 17.4956055 16.17399 19.4694886 23.6434786 12 31.2211914 15.5959473 38 12.5815755"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(0, 5)",
  id: "Path-2-Copy-2",
  stroke: "#37809f",
  points: "2 19.7790264 9.59155273 17.4956055 16.17399 19.4694886 23.6434786 12 31.2211914 15.5959473 38 12.5815755"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(0, -5)",
  id: "Path-2-Copy-3",
  stroke: "#37809f",
  points: "2 19.7790264 9.59155273 17.4956055 16.17399 19.4694886 23.6434786 12 31.2211914 15.5959473 38 12.5815755"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStackedLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stacked_line.741218a97a10e8860365c0ad2da21baa.svg";